/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_AgentInputs */

const en_mk_sec_pg_role_agent = /** @type {(inputs: Mk_Sec_Pg_Role_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

const id_mk_sec_pg_role_agent = /** @type {(inputs: Mk_Sec_Pg_Role_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen`)
};

/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Mk_Sec_Pg_Role_AgentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_agent = /** @type {((inputs?: Mk_Sec_Pg_Role_AgentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_AgentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_agent(inputs)
	return en_mk_sec_pg_role_agent(inputs)
});